module.exports = __webpack_public_path__ + "img/image_why02.b44fc874.png";